import { Alpha3Code } from 'i18n-iso-countries'

import { Organisation } from '@percent/domain/verifications'
import { SubmitCheckOutcome } from '@percent/admin-dashboard/app/monetaryVerifications/monetaryVerificationsDetails/checksSummary/submitCheckModal/SubmitCheckModal.types'

export type GetMonetaryVerificationsProps = {
  page?: number
  pageSize?: number
  cursor?: string | null
  organisationId?: string | null
  partnerIds?: string[] | null
  statuses?: MonetaryVerificationStatus[] | null
  direction?: 'ASC' | 'DESC' | null
}

export type MonetaryVerification = {
  id: string
  status: MonetaryVerificationStatus
  organisationDetails: OrganisationDetails
  createdAt: string
  updatedAt: string | null
  rejectedAt: string | null
  approvedAt: string | null
  partner: Partner
}

export enum MonetaryVerificationStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  EXPIRED = 'expired'
}

export type OrganisationDetails = {
  name: string
  countryCode: Alpha3Code
}

export enum MonetaryVerificationCheckStatus {
  PENDING = 'pending',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed'
}

export type ContactDetails = {
  lastName?: string
  firstName?: string
  primaryEmail?: string
}
export type MonetaryVerificationDetails = {
  id: string
  configurationId: string
  organisationId: string | null
  organisationDetails: Organisation | null
  status: MonetaryVerificationStatus
  createdAt: string
  updatedAt: string | null
  resolvedAt: string | null
  validationSubmissionId: string | null
  partnerName: string | null
  checks: MonetaryVerificationCheck[]
  contactDetails: ContactDetails[]
}

export const ProfileDataCheckReasons = {
  CLAIM_REJECTED: 'claimRejected',
  CONSENT_FORM_REJECTED: 'consentFormRejected',
  LOGO_NOT_PROVIDED: 'logoNotProvided'
} as const

export type ProfileDataCheckReason = typeof ProfileDataCheckReasons[keyof typeof ProfileDataCheckReasons]

export type MonetaryVerificationCheck = {
  type: CheckType
} & MonetaryDonationVerificationCheck

export enum CheckType {
  PAYMENT_DETAILS_CHECK = 'payment_details_check',
  UBO_CHECK = 'ubo_check',
  PROFILE_DATA_CHECK = 'profile_data_check',
  ADYEN_SPECIFIC_CHECK = 'adyen_specific_check',
  VALIDATION_SUBMISSION = 'validation_submission'
}

export enum CheckErrorType {
  MISSING_CHECK_CONFIG = 'missing_check_config',
  GENERIC_ERROR = 'generic_error'
}

export enum CheckDomain {
  VALIDATION = 'validation',
  DISBURSEMENT = 'disbursement',
  EXPERIENCE = 'experience',
  COMPLIANCE = 'compliance'
}

export type Partner = {
  id: string
  name: string
}

export type SubmitCheckRequestPayload = {
  configurationId: string
  resolution: SubmitCheckOutcome
  reason?: string
  isMistakeCorrection?: boolean
}

export type SubmitProfileDataCheckResponse = {
  data: {
    profileDataCheckId: string
    status: MonetaryVerificationCheckStatus
  }
}

export type SubmitUboCheckResponse = {
  data: {
    uboCheckId: string
    status: MonetaryVerificationCheckStatus
  }
}

export type SubmitPaymentDetailsCheckResponse = {
  data: {
    paymentDetailsCheckId: string
    status: MonetaryVerificationCheckStatus
  }
}

export type SubmitAdyenSpecificCheckResponse = {
  data: {
    adyenSpecificCheckId: string
    status: MonetaryVerificationCheckStatus
  }
}

export type MonetaryDonationVerificationCheck = {
  status: MonetaryVerificationCheckStatus
  // NOTE: union with string cause of possible custom reason
  reason?: ProfileDataCheckReason | string
}
